import { CloseButton, Stack, Text } from "@chakra-ui/react";
import { useState } from "react";
import { OnboardingConfirmCancel } from "./OnboardingConfirmCancel";
import { OnboardingListItem } from "./OnboardingListItem";

interface OnboardingModalProps {
  sequences: Record<string, { title: string; duration: string; steps: any[] }>;
  completedSequences: string[];
  onSelectSequence: (sequence: string) => void;
  onToggleOnboarding: (shouldShow: boolean) => void;
}

const getStartedTitle = "Get started with Prompt Studio";
const getStartedDescription =
  "Take a quick tour and save hours at work. We'll guide you through building your first workflow quickly.";

export const OnboardingModal = (props: OnboardingModalProps) => {
  const { sequences, completedSequences, onToggleOnboarding, onSelectSequence } = props;
  const [showCancelConfirmation, setShowCancelConfirmation] = useState(false);
  return (
    <>
      {!showCancelConfirmation && (
        <Stack
          borderRadius={"0.5rem"}
          color="foreground.inverse"
          position="absolute"
          bottom="1rem"
          right="4rem"
          background="foreground.primary"
          padding="1.5rem"
          gap="0"
          maxWidth={"23rem"}
        >
          <CloseButton
            padding="0"
            position="absolute"
            right="1rem"
            top="1.25rem"
            onClick={() => setShowCancelConfirmation(true)}
          />
          <Text color="foreground.inverse" textStyle="label/L/medium">
            {getStartedTitle}
          </Text>
          <Text mt={"1.5rem"} mb={"2rem"} textStyle="body/M">
            {getStartedDescription}
          </Text>
          <Stack>
            {Object.entries(sequences).map(([id, sequence]) => (
              <OnboardingListItem
                key={id}
                isCompleted={completedSequences.includes(id)}
                steps={sequence.steps}
                title={sequence.title}
                duration={sequence.duration}
                onClick={() => onSelectSequence(id)}
              />
            ))}
          </Stack>
        </Stack>
      )}
      {showCancelConfirmation && (
        <OnboardingConfirmCancel
          onCancel={() => setShowCancelConfirmation(false)}
          onToggleOnboarding={onToggleOnboarding}
        />
      )}
    </>
  );
};
